const ImageActionBar = ({imageUrl, redoImage}) => {
  const copyImageUrlButtonClicked = async () => {
    navigator.clipboard.writeText(imageUrl);

    const status = document.getElementById('copyIndicator');
    status.textContent = 'Copied!';
    setTimeout(() => {status.textContent = '';}, 750);
  }

  return (
    <div>
      <a id="downloadImageAction" href={imageUrl} download>
          <button className="ui download icon basic tiny button">
            <i className="download icon"></i>
          </button>
      </a>
      <button id="copyImageButton" className="ui copy outline icon basic tiny button" onClick={copyImageUrlButtonClicked}>
        <i className="copy outline icon"></i>
      </button>
      <button className="ui redo icon basic tiny button" onClick={redoImage}>
        <i className="redo icon"></i>
      </button>
      <div id="copyIndicator"></div>
    </div>
  )

};

export default ImageActionBar;